import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(username, password, admin, enabled) {
  return yield oncallFetch("/api/oncall/partners/users/add", {
    username,
    password,
    admin,
    enabled,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/users/add.js